module.exports = __webpack_public_path__ + "img/eagleEyeLogo.eeba2bcf.png";